import { useAuth } from '@/hooks/useAuth';
import { useUsersGetMe } from '@api/WhisApi/generated/users/users';
import { useEffect } from 'react';

export const UserPrefetcher = (): null => {
  const { isAuthenticated, updateUserFetchState } = useAuth();

  const { data, isLoading, isError, error } = useUsersGetMe({
    query: {
      enabled: isAuthenticated,
      retry: 3,
      refetchOnWindowFocus: false,
    },
  });

  useEffect(() => {
    if (!isAuthenticated) {
      updateUserFetchState({ status: 'idle', user: null, error: null });
      return;
    }

    if (isLoading) {
      updateUserFetchState({ status: 'loading' });
      return;
    }

    if (isError) {
      const normalizedError =
        error instanceof Error
          ? error
          : new Error('Unable to load your account information');

      updateUserFetchState({ status: 'error', error: normalizedError });
      return;
    }

    if (data) {
      updateUserFetchState({ status: 'ready', user: data, error: null });
    }
  }, [isAuthenticated, isLoading, isError, data, error, updateUserFetchState]);

  return null;
};
